import React from 'react';
import useTranslate from '../useTranslate';
import Postit from '../main/postit';
import { APP_LINK } from '../../constants';

function RolesInfoCard() {
    const strings = useTranslate('RolesInfoCard');
    return (
        <Postit>
            <p>{strings.general}</p>
            <strong>{strings.laundryUserTitle}</strong>
            <br />
            {strings.laundryUserBody1}
            <a href={APP_LINK} target="_blank">
                {strings.userAppLinkText}
            </a>{' '}
            {strings.laundryUserBody2}
            <ul>
                <li className={'mt-2'}>{strings.laundryUserSubRole1}</li>
                <li className={'mt-2'}>
                    {strings.laundryUserSubRole2a}
                    <strong>
                        <sup>*</sup>
                    </strong>
                    <br />
                    {strings.laundryUserSubRole2b}
                </li>
            </ul>
            <strong>
                <sup>* </sup>
            </strong>
            {strings.laundryUserSubRole2Explanation}
        </Postit>
    );
}

export default RolesInfoCard;
